// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ListIcon = /* @__PURE__ */ createIcon(
  'list',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M2 18a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zM2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zM2 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0m19-1a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2z',
      },
    ],
  ]
);
